(function () {

    "use strict";

    function aplicacionesController(basicListService, aplicacionesService) {

        var vm = basicListService.instantiate(this);

        vm.service = aplicacionesService;
        vm.templateModalEdit = false;
        vm.stateForEdit = "aplicacion";
        vm.showCreate = true;
        vm.configHead(breadcrumbItems());
        vm.getItemsPaged();

       vm.aditionalLabels = ["Estado"];
       
        function breadcrumbItems() {
            return [{
                text: "Inicio",
                action: vm.goHome
            }, {
                text: "Aplicaciones",
                action: null
            }
            ];
        }
    }

    aplicacionesController.$inject = ["sphforms.basicListService", "sphforms.aplicacionesService"];

    angular.module("sphforms.formacion")
        .component("sphformsAplicaciones", {
            controller: aplicacionesController,
            templateUrl: "modules/formacion/components/aplicaciones/aplicaciones.template.html"
        });

}());
